import { flag, integer, list, optionalText, record, text } from '../../../shared/decode'
import { emptyText, stableIdentity } from '../../../shared/candidates'
import type { CashierAudit, CashierDirectory, CashierMember, CashierPerson } from '../model/types'

function member(raw: unknown, name: string): CashierMember {
  const v = record(raw, name)
  return { ...stableIdentity(v, name), resourceId: text(v.resourceId, name), key: text(v.key, name), name: emptyText(v.name, name), resourceName: text(v.resourceName, name), observedMonth: optionalText(v.observedMonth, name) }
}
export function decodeCashierPerson(raw: unknown, name = 'person'): CashierPerson {
  const v = record(raw, name)
  return { id: text(v.id, name), name: text(v.name, name), version: integer(v.version, name), archived: flag(v.archived, name), canEdit: flag(v.canEdit, name), unified: flag(v.unified, name), members: list(v.members, name, member) }
}
export function decodeCashierDirectory(raw: unknown): CashierDirectory {
  const v = record(raw, 'directory')
  return { people: list(v.people, 'people', decodeCashierPerson), sources: list(v.sources, 'sources', (entry, name) => {
    const item = record(entry, name)
    return { id: text(item.id, name), name: text(item.name, name), kind: optionalText(item.kind, name) ?? '' }
  }), canManage: flag(v.canManage, 'canManage') }
}
export function decodeCashierAudit(raw: unknown): CashierAudit[] {
  return list(raw, 'audit', (entry, name) => { const v = record(entry, name); return { operationId: text(v.operationId, name), actor: text(v.actor, name), at: text(v.at, name), before: text(v.before, name), after: text(v.after, name) } })
}
